import { RequestInterface } from '~/common/types';
import { Setting } from '~/reports/types';

export class UpdateReportSettingsRequest implements RequestInterface {
  method = 'post';
  path: string;
  headers: Record<string, any>;
  data: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    settings,
    params,
  }: {
    token: string;
    settings: Setting;
    params?: Record<string, any>;
  }) {
    this.path = `/api/v1/report-settings`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    this.data = {
      ...settings,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}

export class GetReportSettingsRequest implements RequestInterface {
  method = 'get';
  path: string;
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    params,
  }: {
    token: string;
    params?: Record<string, any>;
  }) {
    this.path = `/api/v1/report-settings`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = { ...params };
    }
  }
}

export class GetSectionReportRequest implements RequestInterface {
  method = 'get';
  path: string;
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    params,
  }: {
    token: string;
    params?: Record<string, any>;
  }) {
    this.path = `/api/v1/report/section-report`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = { ...params };
    }
  }
}

export class GetUserReportVersionRequest implements RequestInterface {
  method = 'get';
  path: string;
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    params,
    userId,
  }: {
    token: string;
    params?: Record<string, any>;
    userId: string;
  }) {
    this.path = `/api/v1/report/${userId}`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = { ...params };
    }
  }
}
